import {
  IconRotate2,
  IconRotateClockwise2,
  IconTrash,
  IconTrashOff,
} from '@rossum/ui/icons/tabler';
import { Stack, SvgIcon } from '@rossum/ui/material';
import { DispatchEdit, Page } from '../document-edit-core';
import { ContainedIconButton } from './ContainedIconButton';

export const EditedPageActions = ({
  page,
  dispatchEdit,
}: {
  page: Page;
  dispatchEdit: DispatchEdit;
}) => {
  return (
    <Stack
      direction="row"
      spacing={1}
      data-cy="page-actions"
      sx={{
        opacity: 0,
        position: 'absolute',
        '&:hover': {
          opacity: 1,
        },
        left: 0,
        top: 0,
        width: '100%',
        height: '100%',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <ContainedIconButton
        onClick={e => {
          e.stopPropagation();
          dispatchEdit({
            type: 'ROTATE_PAGE',
            pageNumber: page.pageNumber,
            rotationDeg: page.rotationDeg - 90,
          });
        }}
        disabled={page.deleted}
        data-no-dnd="true"
        data-cy="document-edit-rotate-page-counter-clockwise-btn"
      >
        <SvgIcon fontSize="medium">
          <IconRotate2 />
        </SvgIcon>
      </ContainedIconButton>
      <ContainedIconButton
        onClick={e => {
          e.stopPropagation();
          dispatchEdit({
            type: 'ROTATE_PAGE',
            pageNumber: page.pageNumber,
            rotationDeg: page.rotationDeg + 90,
          });
        }}
        disabled={page.deleted}
        data-no-dnd="true"
        data-cy="document-edit-rotate-page-clockwise-btn"
      >
        <SvgIcon fontSize="medium">
          <IconRotateClockwise2 />
        </SvgIcon>
      </ContainedIconButton>
      <ContainedIconButton
        onClick={e => {
          e.stopPropagation();
          dispatchEdit({
            type: 'DELETE_PAGE',
            pageNumber: page.pageNumber,
            deleted: !page.deleted,
          });
        }}
        data-no-dnd="true"
        data-cy="document-edit-delete-page-btn"
      >
        <SvgIcon fontSize="medium">
          {page.deleted ? <IconTrashOff /> : <IconTrash />}
        </SvgIcon>
      </ContainedIconButton>
    </Stack>
  );
};
